import { Link } from '@reach/router';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';

import { CommonContextV2, CommonLayoutV2, CustomButtonV2 } from 'components/v2';

import { axios } from 'services/axios';
import { logService } from 'services/LogService';

import warningIcon from 'assets/images/v2/warning-icon-red.svg';

import './confirm-disable-mfa.scss';

const ConfirmDisableMfaPage = () => {
    const { query } = useContext(CommonContextV2);

    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        const token = query?.disable_mfa_tk;
        if (!token) {
            setIsLoading(false);
            return;
        }

        const confirmDisableMfa = async () => {
            try {
                const response = await axios.post('/mfa/disable/confirm', { disableMfaTk: token });
                if (response.status === 200 && response.data?.success) {
                    setIsSuccess(true);
                }
            } catch (err) {
                logService.error('Failed to disable MFA:', err);
            } finally {
                setIsLoading(false);
            }
        };

        confirmDisableMfa();
    }, [query]);

    const renderContent = () => {
        const title = isSuccess ? 'MFA Disabled Successfully' : 'Link Invalid or Expired';
        const description = isSuccess
            ? 'Multi-Factor Authentication (MFA) has been turned off for your account. For your security, we recommend re-enabling MFA when appropriate.'
            : 'This link has expired or is no longer valid. To continue disabling MFA, please <strong>sign in again and enter a recovery code</strong> to request a new confirmation link';
        const buttonText = isSuccess ? 'Continue to Sign In' : 'Back to Sign In';

        return (
            <>
                <div className='confirm-disable-mfa__content'>
                    <div className='confirm-disable-mfa__title'>
                        {!isSuccess && <img src={warningIcon} alt='Warning' className='confirm-disable-mfa__icon' />}
                        <h3>{title}</h3>
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <Link to='/login'>
                    <CustomButtonV2>{buttonText}</CustomButtonV2>
                </Link>
            </>
        );
    };

    return (
        <CommonLayoutV2
            isLoading={isLoading}
            pageTitle='OPSWAT Accounts | Disable Two-Factor Authentication'
            contentStyles={{
                gap: '40px'
            }}
        >
            <div className='confirm-disable-mfa__container'>{renderContent()}</div>
        </CommonLayoutV2>
    );
};

export default ConfirmDisableMfaPage;

ConfirmDisableMfaPage.propTypes = {
    location: PropTypes.object
};
